var map = {
	"./amazon.svg": "2df2",
	"./amazon2.svg": "8992",
	"./american-express.svg": "41c4",
	"./bitcoin-1.svg": "1547",
	"./bitcoin-2.svg": "d917",
	"./bitcoin-3.svg": "d730",
	"./bitcoin-4.svg": "72b2",
	"./cb.svg": "348d",
	"./cirrus.svg": "528d",
	"./delta.svg": "6db8",
	"./diners.svg": "aaf5",
	"./direct-debit.svg": "cb58",
	"./discover.svg": "3b69",
	"./generic.svg": "199e",
	"./genericalternative.svg": "bf55",
	"./jcb.svg": "20fa",
	"./klarna-1.svg": "5f72",
	"./klarna-2.svg": "9a1f",
	"./maestro.svg": "b441",
	"./mastercard.svg": "a23e",
	"./paypal.svg": "6ca2",
	"./paypal2.svg": "5d66",
	"./solo.svg": "929f",
	"./switch.svg": "f39c",
	"./union-pay.svg": "1b68",
	"./visa-electron.svg": "384c",
	"./visa.svg": "81269",
	"./western-union.svg": "a1e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "365a";